import { useEffect } from "react";
import { useLocation } from "react-router";
import Sidebar from "./SideBar/SideBar";
import NavBar from "./SideBar/Navbar";

const MainLayout = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex lg:h-screen sm:h-[100%] md:h-[100%] bg-[#F5F6FA]">
      <Sidebar currentPath={location.pathname} />
      <div className="flex flex-col flex-1">
        <NavBar />
        <div className="p-8 overflow-auto bg-[#F5F6FA]">{children}</div>
      </div>
    </div>
  );
};

export default MainLayout;
